import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/returnStatistic',
    method: 'post',
    data: data
  });
}